module.exports = __webpack_public_path__ + "img/Betreuungszug.686d7682.svg";